/// <reference path="../../app.d.ts"/>

import { defaults } from '../defaults';

import { CalculatorController } from './steps/CalculatorController';

export class App implements AppController {

	private readonly loader: BasicLoader<IbanAppDefinition>;
	// check if this.options is called from somewhereelse (especially from T.Utils.Application)
	private readonly options: BasicAppOptions<IbanAppDefinition>;
	private readonly $ctx: JQuery;
	private ibanCalculatorController: CalculatorController;

	 
	constructor(element: HTMLElement, options: BasicAppOptions<IbanAppDefinition>, loader: BasicLoader<IbanAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		this.evaluateApplicationState(() => {
			this.ibanCalculatorController = new CalculatorController(this, this.options, this.loader);
			this.ibanCalculatorController.start();
		});
	}

	// remove from public interface after refactoring von formmembership
	public validateIban(
		successCallback: () => void,
		errorCallback: () => void): void {
		this.ibanCalculatorController.validateIban(successCallback, errorCallback);
	}


	/**
	 * the application checks if it's storage is working
	 * and places it's own styles in the DOM
	 */
	private evaluateApplicationState(callback: () => void): void {
		if (!this.options.app.currenttemplate) {
			this.options.app.currenttemplate = this.options.app.templates[Object.keys(this.options.app.templates)[0]];
		}
		callback();
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);

		S.Utils.Lightbox.init();
		this.loader.complete();
	}
}
